import { FileDown, Trash2, Hash } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog";

export const IncidentActionBar = ({ draft, downloading, onExportPdf, onDelete }) => (
  <div className="flex items-center justify-between gap-4 px-6 py-4 border-b border-border">
    <div className="flex items-center gap-2 text-xs font-mono text-muted-foreground min-w-0">
      <Hash className="w-3.5 h-3.5 shrink-0" />
      <span data-testid="incident-number" className="text-white font-bold tracking-widest shrink-0">{draft.incident_number || draft.call_id || draft.id}</span>
      {draft.title && (
        <>
          <span className="shrink-0">—</span>
          <span data-testid="incident-bar-title" className="font-sans text-sm text-white truncate min-w-0" title={draft.title}>{draft.title}</span>
        </>
      )}
      {draft.source === "simulation" && (
        <span className="ml-2 px-2 py-0.5 border border-[#FFCC00]/40 text-[#FFCC00] uppercase tracking-widest shrink-0">Simulated</span>
      )}
    </div>
    <div className="flex items-center gap-2 shrink-0">
      <Button variant="outline" size="sm" onClick={onExportPdf} disabled={downloading === "pdf"} data-testid="download-btn"
        className="rounded-sm border-border gap-2"><FileDown className="w-4 h-4" /> {downloading === "pdf" ? "…" : "Export PDF"}</Button>
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <Button variant="outline" size="sm" data-testid="delete-btn"
            className="rounded-sm border-[#FF3B30]/40 text-[#FF3B30] hover:bg-[#FF3B30]/10 hover:text-[#FF3B30] gap-2">
            <Trash2 className="w-4 h-4" /> Delete
          </Button>
        </AlertDialogTrigger>
        <AlertDialogContent className="bg-[#0A0A0A] border-border rounded-sm">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-heading">Delete this incident?</AlertDialogTitle>
            <AlertDialogDescription>This permanently removes the report and transcript.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="rounded-sm">Cancel</AlertDialogCancel>
            <AlertDialogAction onClick={onDelete} data-testid="confirm-delete"
              className="rounded-sm bg-[#FF3B30] hover:bg-[#d62f26] text-white">Delete</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  </div>
);
